import { isEmpty } from "lodash";
import { LOCAL_USER_MANAGEMENT_SYSTEM_URL } from "./const";

export function getUmsRedirectUrl() {
  const REACT_ENV = process.env.NODE_ENV;
  const SANCTIONS_URL =
    !!process.env.REACT_APP_UMS_SYSTEM_URL && process.env.REACT_APP_UMS_SYSTEM_URL !== "" ? process.env.REACT_APP_UMS_SYSTEM_URL : LOCAL_USER_MANAGEMENT_SYSTEM_URL;
  if (!isEmpty(REACT_ENV)) {
    return SANCTIONS_URL;
  } else {
    return LOCAL_USER_MANAGEMENT_SYSTEM_URL;
  }
}

export const getUmsRedirectionUrl = () => {
  return getUmsRedirectUrl();
};
